import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CheckoutHistory } from 'src/app/models/checkout-history';
import { Record, Icon } from 'src/app/models/record';
import { UserService } from 'src/app/services/user.service';
import { ApiService } from 'src/app/services/api.service';
import { Util } from 'src/app/util';
import { CustomerType } from '../../../models/client-configuration';
import { ConfigService } from '../../../services/config.service';

@Component({
  selector: 'app-user-checkout-history-item',
  templateUrl: './user-checkout-history-item.component.html',
  styleUrls: ['./user-checkout-history-item.component.scss'],
})
export class UserCheckoutHistoryItemComponent implements OnInit {
  @Input()
  checkout: CheckoutHistory;

  @Output()
  removed = new EventEmitter<CheckoutHistory>();

  userService: UserService;
  record: Record;
  slug: string;
  icon: Icon;
  shouldStack: boolean;
  customerType: CustomerType;

  constructor(
    userService: UserService,
    private apiService: ApiService,
    private configService: ConfigService
  ) {
    this.userService = userService;
  }

  ngOnInit() {
    this.shouldStack = ['MAGAZINE', 'NEWSPAPER'].includes(this.checkout.format);
    this.apiService.getRecord(this.checkout.recordId).subscribe(
      (record) => {
        this.record = record;
        this.slug = Util.slugifyRecord(record);
      },
      (_) => this.removed.emit(this.checkout)
    );
    this.customerType = this.configService.customerType;
  }

  onRemoved(checkout: CheckoutHistory) {
    this.removed.emit(checkout);
  }
}
